<template>
    <div>
        <v-card elevation="0">
            <!--
                <v-card-title style="color:#6f9483;" class="text-center">
                    <v-icon color="#6f9483">mdi-upload</v-icon> Upload File
                </v-card-title>
            -->
            <v-card-text>
                <v-row>
                    <v-col md="12">
                        <v-select
                            v-model="chosenUploadType"
                            :items="uploadTypes"
                            outlined
                            id="uploadMode"
                            @change="validateForm"
                            :loading="loading"
                            hint="Upload Type"
                            :disabled="loading"
                            persistent-hint
                            prepend-icon="mdi-tag"
                        >
                        </v-select>
                    </v-col>
                    <v-col md="12">
                        <v-file-input
                            accept=".csv"
                            label="Choose ONE CSV file"
                            outlined
                            counter
                            id="uploadFile"
                            v-model="userFile"
                            @change="validateForm"
                            hint="File Upload"
                            persistent-hint
                        ></v-file-input>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-dialog
                    v-model="dialog"
                    persistent
                    width="500"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            :disabled="submitDisabled"
                            color="#8FB3A3"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <span style="color: white;">Upload</span>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-form target="hiddenFrame" @submit="submitForm">
                            <v-toolbar elevation="1" dark color="#8FB3A3">
                                <v-toolbar-title>Upload File?</v-toolbar-title>
                            </v-toolbar><br />
                            <v-card-subtitle>You are uploading:</v-card-subtitle>
                            <v-card-text>
                                Type: <b>{{ chosenUploadType }}</b> <br /> <br />
                                File: <b>{{ filename }}</b> <br />
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="#E53935"
                                outlined
                                @click="dialog = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                color="#8FB3A3"
                                outlined
                                type="submit"
                                :loading="uploadloading"
                            >
                                OK
                            </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-card-actions>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    name: "NetBillUploadFile",
    data(){
        return {
           host: location.hostname.toString(),
            chosenUploadType: "Please Select...",
            uploadTypes : [
                {"text": "Please Select...", "value": "Please Select..."}
            ],
            userFile: null,
            filename: "",
            submitDisabled: true,
            uploadloading: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            loading: true,
            dialog: false,
        }
    },
    methods: {
        getUploadTypes(){
            const that = this;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api-netbill.pl?adminuploadtypesget';

            var general = [
                {"text": "Please Select...", "value": "Please Select..."}
            ];
            var term1 = [
                {"header": "Term 1"}
            ];
            var term2 = [
                {"header": "Term 2"}
            ];

            //API GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                        that.loading = false;
                    }
                    if(resultData.data){
                        for(var i=0; i< resultData.data.length; i++){
                            if(resultData.data[i].header.match(/^Term 1/i)){
                                term1.push({"text": resultData.data[i].text,"value": resultData.data[i].text});
                            }else if(resultData.data[i].header.match(/^Term 2/i)){
                                term2.push({"text": resultData.data[i].text,"value": resultData.data[i].text});
                            }else {
                                general.push({"text": resultData.data[i].text,"value": resultData.data[i].text});
                            }
                        }

                        that.uploadTypes = [ ...general, ...term1, ...term2];
                        that.loading = false;
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                        that.loading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.loading = false;
                })
            //End of API GET request
        },
        validateForm(){
            const that = this;
            //Upload Button control

            if(that.chosenUploadType.match(/^Please Select/i) || that.userFile == null){ //Checks if any two inputs are empty or not
                that.submitDisabled = true;
            }else {
                that.submitDisabled = false;
            }

            if(that.userFile != null){
                that.filename = document.getElementById("uploadFile").files[0].name;
                if(that.filename.split(".").slice(-1)[0].match(/^csv/i)){ //Checks if the uploaded file extension is .csv
                    that.submitDisabled = false;
                }else{
                    that.submitDisabled = true;
                }
            }
        },
        submitForm(){
            const that = this;
            that.uploadloading = true;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py';

            const formData = new FormData();
            formData.append("mode", "adminnetbillupload");
            formData.append("uploadFile", that.userFile);
            formData.append("data", JSON.stringify({
                uploadtype : that.chosenUploadType
            }));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Successful: "+data.message.toString(), "green");
                    that.uploadloading = false;
                    that.dialog = false;
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                    that.uploadloading = false;
                    that.dialog = false;
                }


                that.submitDisabled = true;
                that.chosenUploadType = "Please Select...";
                that.userFile = null;
                
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.uploadloading = false;
                that.dialog = false;
            })

        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getUploadTypes();
    }
}
</script>